import { uuid } from 'uuidv4';

const createAvailability = (obj, duration) => {
  const client = {
    type: 'client',
    raw: {
      group: []
    },
    id: uuid(),
    time: {
      start: obj.time.start,
      end: obj.time.start + 1000 * 60 * duration
    },
    timezone: ''
  };
  const expert = {
    type: 'expert',
    raw: {
      group: []
    },
    id: uuid(),
    time: {
      start: obj.time.start,
      end: obj.time.start + 1000 * 60 * duration
    },
    timezone: ''
  };
  return [client, expert];
};

export default createAvailability;